<div class="modal-header">
  <h4 class="modal-title h5" [innerHTML]="pageTitle"></h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<!-- Add/Edit category modal content -->
<form [formGroup]="machineCategoryEditForm" class="edit-menu-form">
  <div class="modal-body">
    <div class="row">
      <div class="col-6">
        <!-- Category form -->
        <div class="form-group">
          <label translate>Category name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input (input)="onInputCategoryName()"
            [ngClass]="{'is-invalid': f.categoryName.errors || isNameExist}"
            type="text"
            class="form-control"
            formControlName="categoryName">
            @if (f.categoryName.errors || isNameExist) {
              <div class="invalid-feedback">
                @if (f.categoryName.errors?.required) {
                  <span
                  translate>Category name is required</span>
                }
                @if (f.categoryName.errors?.pattern) {
                  <span
                  translate>The name can only consist of capital letters, numbers, underscores and has a max length of 32 characters</span>
                }
                @if (isNameExist) {
                  <span
                  [innerHtml]="('Machine category already exists with name' | translate) + ' ' + machineCategory.name"></span>
                }
              </div>
            }
          </div>
          <div class="form-group">
            <label translate>Display name</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <input (input)="onInputDisplayName()"
              [ngClass]="{'is-invalid': f.displayName.errors}"
              type="text"
              class="form-control"
              formControlName="displayName">
              @if (f.displayName.errors) {
                <div class="invalid-feedback">
                  @if (f.displayName.errors?.required) {
                    <span
                    translate>Display name is required</span>
                  }
                  @if (f.displayName.errors?.pattern) {
                    <span
                    translate>The display name can only consist of letters, numbers, spaces, the following special characters: &'_+-! and has a max length of 32 characters</span>
                  }
                </div>
              }
            </div>
            <div class="form-group">
              <label translate>Reference machine</label>
              <em [ngbTooltip]="'This feature requires that machines of the same category have the same machine configuration. Otherwise, \'N/A\' will be shown if it doesn\'t match the reference configuration' | translate"
                class="fa-solid fa-circle-question text-muted ml-1"
              placement="top"></em>
              @if (isLoadingMachinesByCategory) {
                <span class="fa-solid fa-spinner fa-spin ml-2"></span>
              }
              <ng-select [items]="machinesByCategory"
                [hideSelected]="true"
                [placeholder]="('Select Machine' | translate) + ' ...'"
                bindLabel="name"
                formControlName="referenceMachine">
              </ng-select>
            </div>

            <div class="divider"></div>
            <div class="form-group">
              <div class="row mb-2 align-items-center">
                <div class="col-auto">
                  <div class="image-placeholder image-placeholder-circle">
                    <button (click)="deleteIcon()" class="btn btn-xs btn-outline-danger" [title]="'Delete fallback image'|translate">
                      <span class="fa-solid fa-trash"></span>
                    </button>
                    <img alt="" [src]="f.icon.value">
                  </div>
                </div>
                <div class="col">
                  <label translate>Category Icon</label>
                  <em [ngbTooltip]="'This image shows up on machine tiles and category lists.' | translate"
                    class="fa-solid fa-circle-question text-muted ml-1"
                  placement="top"></em>
                  <scitis-required-field-indicator></scitis-required-field-indicator>
                  <small translate class="mb-2 d-block">Only .png and .jpg files are supported.</small>
                  <small translate class="mb-2 d-block">The image dimensions cannot exceed 300x300 pixels and image size cannot exceed 30kb.</small>
                </div>
              </div>
              <scitis-file-upload
                (fileLoadError)="onFileUploadError($event)"
                (fileLoadEvent)="onFileUploadComplete($event)"
                label="Browse"
                [maxImageHeight]="maxImageHeight"
                [maxImageWidth]="maxImageWidth"
                [maxFileSize]="maxFileSize"
                [fileTypes]="imageFileTypes">
              </scitis-file-upload>
              <input type="hidden" [ngClass]="{'is-invalid': f.icon.errors}" class="form-control" formControlName="icon">
              @if (f.icon.errors) {
                <div  class="invalid-feedback">
                  @if (f.icon.errors?.required) {
                    <span
                    translate>Icon is required</span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-6 modal-side">
            <!-- Colum edit -->
            <div class="modal-side-content">
              <div class="section-fixed bg-light pb-2">
                <strong>
                  <label translate>Column configuration</label>
                </strong>
                @if (isLoadingColumnConfig || isLoadingMachinesByCategory) {
                  <span class="fa-solid fa-spinner fa-spin ml-2"></span>
                }
              </div>
              <div class="list-group" [(dragulaModel)]="columnConfiguration.categoryColumns" [dragula]="dragAndDropColumns">
                @for (column of columnConfiguration.categoryColumns; track column; let last = $last; let i = $index) {
                  <div>
                    <div class="list-group-item edit-menu-item edit-menu-item-active">
                      <div class="row edit-menu-header">
                        <div (click)="collapse.toggle()" [attr.aria-expanded]="!column.collapsed" class="col">
                          <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
                          <span>
                            <span [innerHTML]="column.label|translate"></span>
                          </span>
                        </div>
                        <div class="col-auto">
                          <div class="edit-menu-item-functions">
                            <div class="d-inline-flex" ngbDropdown container="body">
                              <button class="btn btn-xs btn-outline-primary dropdown-no-arrow" id="dropdownColumn"
                                ngbDropdownToggle>
                                <span class="fa-solid fa-ellipsis-vertical"></span>
                              </button>
                              <div aria-labelledby="dropdownColumn" ngbDropdownMenu>
                                <button (click)="collapse.toggle()" ngbDropdownItem>
                                  <span class="fa-solid fa-pen"></span>
                                  <span translate>Edit</span>
                                </button>
                                <button (click)="onDeleteColumn(column)"
                                  [ngClass]="{'text-danger': column.deletable}"
                                  [disabled]="!column.deletable"
                                  ngbDropdownItem>
                                  <span class="fa-solid fa-trash"></span>
                                  <span translate>Delete</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div #collapse="ngbCollapse" [ngbCollapse]="isCollapsed(column.collapsed)">
                        <scitis-machine-category-edit-column
                          (isColumnFormInvalid)="isColumnInvalid($event, i)"
                          [last]="last"
                          [refMachine]="f.referenceMachine.value"
                          [isLoadingMachine]="isLoadingMachine"
                          [metaDataForRefMachine]="metaDataForRefMachine"
                          [signalsForRefMachine]="signalsForRefMachine"
                          [baseColumn]="column">
                        </scitis-machine-category-edit-column>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div class="modal-side-buttons">
              <button (click)="onAddColumn()" class="btn btn-outline-primary">
                <span class="fa-solid fa-plus"></span>
                <span translate>Add Column</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <scitis-modal-footer (cancelButtonPressed)="onCancel()"
      (okButtonPressed)="onSave()"
      [cancelButtonText]="'Cancel'|translate"
      [disableOkButton]="isSaveButtonDisabled"
      [okButtonText]="'Save'|translate"
      [showRequiredFieldsIndicator]="true">
    </scitis-modal-footer>
